<template>
  <div id="podcast-container">
    <div class="grid" v-editable="blok">
      <div class="css-grid">
        <template v-for="(test,index) in blok.initpodcasts">
          <AddPodcast :key="index" :blok="test" v-bind:index="index"></AddPodcast>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["blok", "AddPodcast"],
  data() {
    return {};
  }
};
</script>
<style lang="scss">
@import "AppInitPodcasts.scss";
</style>
